import React from 'react'

function ActivePill() {
  return (
    <span className="badge bg-light text-uppercase py-2 pe-4">
      <span style={{width: '8px', height: '8px'}} className="bg-success rounded-circle me-2" />
      Active
    </span>
  )
}

export default ActivePill
